import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Donate } from "../images/icons";
// import { DumeleIcon, HivosIcon } from "../images/logos";
import { Link as LinkS } from "react-scroll";
import { GiHamburgerMenu } from "react-icons/gi";
import navLogos from "../images/nav-logos.png";

const Navbar = () => {
  return (
    <div className="h-[110px] md:h-[100] bg-black text-white flex items-center w-full sticky top-0 z-[990]">
      {/* <div className="sidebar bg-red absolute bottom-[-500px] right-0 w-full h-[300px] flex flex-col"></div> */}
      <div className="h-full flex flex-1 items-center px-16 md:px-6 justify-between">
        {/* <div className="flex items-center space-x-6">
          <DumeleIcon /> <HivosIcon />
        </div> */}
        <div className="w-[220px] md:w-[160px]">
          <img src={navLogos} alt="" className="w-full" />
        </div>
        <div className="md-min:hidden">
          <div></div>
          <div>
            <GiHamburgerMenu className="text-3xl" />
          </div>
        </div>
        <div className="nav-links md:hidden">
          <ul className="flex space-x-16">
            <li>
              <NavLink
                to="/"
                className={(navData) =>
                  navData.isActive ? "font-extrabold" : "font-semibold"
                }
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/about"
                className={(navData) =>
                  navData.isActive ? "font-extrabold" : "font-semibold"
                }
              >
                About
              </NavLink>
            </li>
            <li>
              <LinkS
                to="collection"
                className="font-semibold cursor-pointer"
                smooth={true}
                duration={500}
                spy={true}
                offset={-20}
              >
                Collection
              </LinkS>
            </li>
          </ul>
        </div>
      </div>
      <button className="bg-white text-black h-full px-12 font-semibold md:hidden">
        <Link
          to="/"
          className="h-full flex items-center justify-center space-x-2"
        >
          <span>Coming Soon</span>
          <span>
            <Donate />
          </span>
        </Link>
      </button>
    </div>
  );
};

export default Navbar;
